import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';

import { CoacheeSettingsController } from 'presentation/page/settings/coachee-settings/coachee-settings.controller';

@Component({
	selector: 'spr-settings-notifications',
	templateUrl: './settings-notifications.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsNotificationsComponent implements OnInit {
	public form: FormGroup;

	constructor(
		public controller: CoacheeSettingsController,
		private _controlContainer: ControlContainer
	) {}

	ngOnInit(): void {
		this.form = this._controlContainer.control as FormGroup;
	}

	public onSaveClick() {
		this.controller.save().subscribe();
	}
}
